import { QUERY_PARAMS_KEY } from './queryParams'

export const LOGOUT = 'LOGOUT'
export const LAST_LOGIN_DATA = 'LAST_LOGIN_DATA'
export const REMOTE_SESSION_DATA = 'REMOTE_SESSION_DATA'
export const REMOTE_SESSION_TIME = 'REMOTE_SESSION_TIME'
export const COLTENE_BRANCH_UUID = 'COLTENE_BRANCH_UUID'
export const COLTENE_BRANCHES = 'COLTENE_BRANCHES'

export function handleLogout() {
  return {
    type: LOGOUT,
  }
}

export function handleUserLogout() {
  return (dispatch) => {
    dispatch(handleLogout())
    localStorage.removeItem(LAST_LOGIN_DATA)
    localStorage.removeItem(REMOTE_SESSION_DATA)
    localStorage.removeItem(REMOTE_SESSION_TIME)
    localStorage.removeItem(QUERY_PARAMS_KEY)
    localStorage.removeItem(COLTENE_BRANCHES)
  }
}
